import { get } from 'lodash-es';
import { AxiosResponse } from 'axios';

export default function responseHandler(response: AxiosResponse) {
  const data = get(response, 'data.data', response.data);
  const { code } = get(response, 'data');
  if (code) {
    return Promise.reject(data);
  }

  return { ...response, ...response.data, data };
}

export const restfulResponseHandler = (response: AxiosResponse) => {
  const data = get(response, 'data', response.data);
  const { code } = data;

  if (code !== 200) {
    return Promise.reject(data);
  }

  return { ...response, ...response.data, data };
};
